import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../../../../components/Icon';

import classnames from 'classnames';
import './iconManager.css';

export const playerStatusById = {
  1: 'uncertain',
  2: 'injured',
  3: 'suspended',
  6: 'missing',
};

export default class IconManager extends React.Component {
  static propTypes = {
    type: PropTypes.object.isRequired,
    playerId: PropTypes.string,
    changePlayerState: PropTypes.func,
    selectedGameWeek: PropTypes.number,
    disabled: PropTypes.bool,
  };

  changeState = (playerId, status, value, gameWeekNumber) => {
    !this.props.disabled &&
      this.props.changePlayerState(playerId, status, value, gameWeekNumber);
  };

  render() {
    const {playerId, type, selectedGameWeek} = this.props;
    return (
      <div id="icon-manager">
        {Object.keys(playerStatusById).map(statusId => (
          <div
            onClick={() =>
              this.changeState(
                playerId,
                parseInt(statusId, 10),
                !(this.props.type === parseInt(statusId, 10)),
                selectedGameWeek,
              )
            }
            className={classnames('iconDisable', {
              iconEnable: type === parseInt(statusId, 10),
            })}>
            <Icon type={playerStatusById[parseInt(statusId, 10)]} />
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Tools/Tds/Widgets/TdsList/iconManager/index.js